<template>
  <v-snackbar color="light-blue lighten-4" :value="needRefreshApp" :light="true" left :timeout="-1">
    <div class="refresh-app-alert-content">
      <span>{{ $t('refreshAppAlert.needUpdateApp') }}</span>
      <v-btn 
        text
        small
        @click="updatePage" 
      >{{ $t('refreshAppAlert.update') }}</v-btn>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    needRefreshApp() {
      return this.$store.state.general.needRefreshApp
    }
  },

  methods: {
    updatePage() {
      document.location.reload()
    }
  }
}
</script>

<style lang="scss">
.refresh-app-alert-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>